<template>
  <div class="pa-10">
    <h1>People</h1>
    <v-btn @click="testWebhook">test</v-btn>
    <div class="d-flex flex-wrap" style="gap: 10px">
      <v-dialog
        :close-on-content-click="false"
        max-width="800"
        v-for="person in people"
        :key="person.uid"
      >
        <template v-slot:activator="{ props: activatorProps }">
          <v-card variant="outlined" class="pa-4" v-bind="activatorProps">
            <v-card-title>
              <p>{{ person.naam }}</p>
              <p style="font-size: 10pt">{{ person.email }}</p>
            </v-card-title>
          </v-card>
        </template>

        <template v-slot:default="{ isActive }">
          <v-card class="pa-4">
            <h2 class="mb-4">{{ person.naam }}</h2>
            <v-tabs v-model="tab">
              <v-tab style="text-transform: none" value="algemeen"
                >Algemeen</v-tab
              >
              <v-tab style="text-transform: none" value="skills">Skills</v-tab>
              <v-tab
                style="text-transform: none"
                value="om-rekening-mee-te-houden"
                >Om rekening mee te houden</v-tab
              >
            </v-tabs>
            <v-divider class="mb-2"></v-divider>

            <v-tabs-window v-model="tab">
              <v-tabs-window-item value="algemeen">
                <v-text-field
                  label="Naam"
                  @change="savePerson(person, person)"
                  v-model="person.naam"
                ></v-text-field>

                <v-text-field
                  label="Email"
                  @change="savePerson(person, person)"
                  v-model="person.email"
                ></v-text-field>
              </v-tabs-window-item>
              <v-tabs-window-item value="skills">
                <div class="d-flex flex-column" style="gap: 10px">
                  <p style="font-size: 10pt">Skills</p>
                  <div v-for="skill in person.skills" :key="skill.skill">
                    <p>{{ skill.skill }}</p>
                    <v-select
                      v-model="skill.level"
                      bg-color="smoke"
                      variant="solo"
                      flat
                      hide-details=""
                      @change="savePerson(person, person)"
                      :items="[
                        'Geen',
                        'Onbekend',
                        'Enkele keer',
                        'Regelmatig',
                        'Expert',
                      ]"
                    ></v-select>
                  </div>
                </div>
              </v-tabs-window-item>
              <v-tabs-window-item value="om-rekening-mee-te-houden">
                <p style="font-size: 10pt">Om rekening mee te houden</p>
                <v-text-field
                  @change="savePerson(person, person)"
                  v-for="(note, index) in person.notes"
                  :key="index"
                  v-model="note.text"
                  >{{ note.text }}</v-text-field
                >
                <v-text-field
                  v-model="newNote"
                  @keydown.enter="
                    person.notes.push({ text: newNote });
                    newNote = '';
                    savePerson(person, person);
                  "
                  label="Om rekening mee te houden"
                >
                </v-text-field>
              </v-tabs-window-item>
            </v-tabs-window>

            <v-card-actions>
              <v-btn @click="isActive.value = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { getDocs, collection, updateDoc, doc } from "firebase/firestore";
import { db } from "@/firebase";
import { mapState } from "vuex";
import { functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";
export default {
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  data() {
    return {
      tab: "algemeen",
      headers: [
        { title: "Name", key: "naam" },
        { title: "Skills", key: "skills" },
      ],
      people: [],
      newNote: "",
    };
  },
  mounted() {
    this.fetchPeople();
  },
  methods: {
    async testWebhook() {
      let people = [];
      const querySnapshot = await getDocs(
        collection(db, "hr", "people", "people")
      );
      querySnapshot.docs.forEach((doc) => {
        people.push({ ...doc.data() });
      });
      console.log(people);
      const testHR = httpsCallable(functions, "testHR");
      const res = await testHR({ personId: "1058024" });
      console.log(res.data);
    },
    async savePerson(person) {
      const docRef = doc(db, "hr", "people", "people", person.uid);
      await updateDoc(docRef, person);
      console.log("Person saved", person);
    },
    async fetchPeople() {
      if (this.user?.uid === "5PYQUTe0v7PYjUjjd79DeLXUff13") {
        const querySnapshot = await getDocs(
          collection(db, "hr", "people", "people")
        );
        this.people = [];
        querySnapshot.docs.forEach((doc) => {
          this.people.push({ ...doc.data(), notes: doc.data().notes || [] });
        });
      }
    },
  },
};
</script>
